// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marketplaceProductCard":"_34R_cd","why-this-product":"XN-yI-"};